import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube, Send } from "lucide-react";
import { CONTACT } from "../../data/cruiseData";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/2ber7617_magic-cruises-sydney-harbour.png";

const CHARTER_GROUPS = [
 {
  heading: "Celebrations · Family",
  items: [
   { l: "Birthday Cruises Sydney",          s: "birthday-cruises-sydney-harbour" },
   { l: "Wedding Cruises Sydney",           s: "wedding-cruises-sydney-harbour" },
   { l: "Engagement Party Cruises",         s: "engagement-party-cruises-sydney" },
   { l: "Proposal & Engagement Cruises",    s: "engagement-proposal-cruises-sydney" },
   { l: "Anniversary Cruises Sydney",       s: "anniversary-cruises-sydney" },
   { l: "Graduation Cruises Sydney",        s: "graduation-cruises-sydney" },
   { l: "School Formal Cruises Sydney",     s: "school-formal-cruises-sydney" },
   { l: "Bridal Shower Cruises",            s: "bridal-shower-cruises-sydney" },
   { l: "Baby Shower Cruises Sydney",       s: "baby-shower-cruises-sydney" },
   { l: "Family Celebration Cruises",       s: "family-celebration-cruises-sydney" },
   { l: "Celebration Cruises",              s: "celebration-cruises-sydney-harbour" },
  ],
 },
 {
  heading: "Parties · Boat Hire",
  items: [
   { l: "Hens Party Cruises",               s: "hens-party-cruises-sydney-harbour" },
   { l: "Boat Party Sydney Harbour",        s: "boat-party-sydney-harbour" },
   { l: "Harbour Party Boat Hire",          s: "harbour-party-boat-hire-sydney" },
   { l: "Cocktail Party Cruises",           s: "cocktail-party-cruises-sydney" },
   { l: "Sunset Cruises",                   s: "sunset-cruises-sydney-harbour" },
   { l: "Private Romantic Dinner Charter",  s: "romantic-dinner-cruises-sydney" },
   { l: "Private Harbour Dining Charter",   s: "harbour-dining-cruises-sydney" },
   { l: "BYO Cruise Sydney Harbour",        s: "byo-cruise-sydney-harbour" },
  ],
 },
 {
  heading: "Corporate · Events",
  items: [
   { l: "Corporate Cruises Sydney",         s: "corporate-cruises-sydney-harbour" },
   { l: "Christmas Party Cruises",          s: "christmas-party-cruises-sydney" },
   { l: "EOFY Cruises Sydney",              s: "eofy-cruises-sydney" },
   { l: "Team Building Cruises",            s: "team-building-cruises-sydney" },
   { l: "Product Launch Cruises",           s: "product-launch-cruises-sydney" },
   { l: "Networking Event Cruises",         s: "networking-event-cruises-sydney" },
   { l: "Harbour Function Venue",           s: "harbour-function-venue-sydney" },
   { l: "Sydney Harbour Event Cruises",     s: "sydney-harbour-event-cruises" },
   { l: "Halloween Cruises",                s: "halloween-cruises-sydney-harbour" },
   { l: "VIP Harbour Cruises",              s: "vip-harbour-cruises-sydney" },
   { l: "Valentines Day Cruises",           s: "valentines-day-cruises-sydney" },
   { l: "Melbourne Cup Cruises",            s: "melbourne-cup-cruises-sydney" },
  ],
 },
 {
  heading: "Boat Hire · Charters",
  items: [
   { l: "Private Boat Hire Sydney",         s: "private-boat-hire-sydney-harbour" },
   { l: "Private Harbour Cruises",          s: "private-harbour-cruises-sydney" },
   { l: "Catamaran Hire Sydney",            s: "catamaran-hire-sydney-harbour" },
   { l: "Boat Hire For Events",             s: "boat-hire-for-events-sydney" },
   { l: "Sydney Harbour Charters",          s: "sydney-harbour-charters" },
  ],
 },
];

export default function Footer() {
 const [email, setEmail] = useState("");
 const [subscribed, setSubscribed] = useState(false);
 const subscribe = (e) => {
 e.preventDefault();
 if (!email.includes("@")) return;
 setSubscribed(true);
 setEmail("");
 setTimeout(() => setSubscribed(false), 4000);
 };

 return (
 <footer className="relative bg-[hsl(225,80%,18%)] text-white mt-24 overflow-hidden" data-testid="site-footer">
 {/* Newsletter banner */}
 <div className="mx-auto max-w-7xl px-5 lg:px-10 pt-20">
 <div className="relative overflow-hidden rounded-3xl p-8 md:p-12 shadow-2xl" style={{ background: "linear-gradient(135deg, hsl(210, 90%, 55%) 0%, hsl(220, 85%, 45%) 60%, hsl(225, 80%, 35%) 100%)" }} data-testid="footer-newsletter">
 <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/10 blur-3xl" />
 <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-amber-300/15 blur-3xl" />
 <div className="relative grid md:grid-cols-2 gap-6 items-center">
 <div>
 <h3 className="text-3xl md:text-4xl font-black text-white leading-tight tracking-tight">
 <span className="text-white">Sail with us,</span> <span className="italic font-light text-amber-300">virtually.</span>
 </h3>
 <p className="text-white/80 text-sm mt-3 max-w-md leading-relaxed">
 Join our newsletter for Sydney Harbour cruise specials, NYE early access &amp; magic moments straight to your inbox.
 </p>
 </div>
 <form onSubmit={subscribe} className="flex gap-2" data-testid="footer-newsletter-form">
 <input
 type="email"
 required
 placeholder="your@email.com"
 value={email}
 onChange={e => setEmail(e.target.value)}
 className="flex-1 min-w-0 px-5 py-3.5 rounded-full text-ink placeholder:text-ink-mute outline-none ring-2 ring-transparent focus:ring-amber-300"
 data-testid="footer-newsletter-input"
 />
 <button type="submit" className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-amber-400 hover:bg-amber-300 text-[hsl(225,80%,14%)] font-bold text-sm transition-colors shrink-0" data-testid="footer-newsletter-btn">
 <Send className="w-4 h-4" /> Subscribe
 </button>
 </form>
 </div>
 {subscribed && (
 <div className="relative mt-4 text-amber-200 text-sm font-medium" data-testid="footer-newsletter-success">
 ✓ You're on the list. Check your inbox.
 </div>
 )}
 </div>
 </div>

 {/* Main grid */}
 <div className="mx-auto max-w-7xl px-5 lg:px-10 pt-20 pb-10">
 <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
 {/* Brand */}
 <div className="md:col-span-4">
 <img src={LOGO_URL} alt="Magic Cruises" className="w-32 object-contain" style={{ filter: "brightness(0) invert(1)" }} />
 <div className="text-[11px] tracking-[0.3em] uppercase text-sky-300 font-bold mt-4">Sydney Harbour · Private Charter</div>
 <p className="text-white/70 text-sm mt-5 leading-relaxed max-w-sm">
 Sydney's most loved private charter catamaran. Two decades, thousands of celebrations, one unforgettable harbour.
 </p>
 <div className="flex gap-3 mt-7">
 <a href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/8 hover:bg-amber-400 hover:text-[hsl(225,80%,14%)] text-white flex items-center justify-center transition-colors ring-1 ring-white/10" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
 <a href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/8 hover:bg-amber-400 hover:text-[hsl(225,80%,14%)] text-white flex items-center justify-center transition-colors ring-1 ring-white/10" data-testid="footer-facebook"><Facebook className="w-4 h-4" /></a>
 <a href="#" aria-label="YouTube" className="w-10 h-10 rounded-full bg-white/8 hover:bg-amber-400 hover:text-[hsl(225,80%,14%)] text-white flex items-center justify-center transition-colors ring-1 ring-white/10" data-testid="footer-youtube"><Youtube className="w-4 h-4" /></a>
 </div>
 </div>

 {/* Cruises */}
 <div className="md:col-span-3">
 <h4 className="text-amber-300 text-xs uppercase tracking-[0.28em] font-bold mb-5">Cruises</h4>
 <ul className="space-y-3 text-sm text-white/80">
 <li><Link to="/cruises" className="hover:text-amber-300 transition-colors">Sydney Harbour Cruises</Link></li>
 <li><Link to="/cruises" className="hover:text-amber-300 transition-colors">Boat Cruises Sydney Harbour</Link></li>
 <li><Link to="/cruises/corporate-cruises-sydney-harbour" className="hover:text-amber-300 transition-colors">Corporate Cruise Sydney</Link></li>
 <li><Link to="/cruises/nye-cruises-sydney-harbour" className="hover:text-amber-300 transition-colors">NYE Cruise Sydney</Link></li>
 <li><Link to="/cruises/byo-cruise-sydney-harbour" className="hover:text-amber-300 transition-colors">BYO Cruise Sydney</Link></li>
             <li><Link to="/packages" className="hover:text-amber-300 transition-colors">Menu &amp; Pricing</Link></li>
 </ul>
 </div>

 {/* Explore */}
 <div className="md:col-span-2">
 <h4 className="text-amber-300 text-xs uppercase tracking-[0.28em] font-bold mb-5">Explore</h4>
 <ul className="space-y-3 text-sm text-white/80">
 <li><Link to="/" className="hover:text-amber-300 transition-colors">Home</Link></li>
 <li><Link to="/gallery" className="hover:text-amber-300 transition-colors">Gallery</Link></li>
 <li><Link to="/availability" className="hover:text-amber-300 transition-colors">Availability</Link></li>
 <li><Link to="/rates-and-menus" className="hover:text-amber-300 transition-colors" data-testid="footer-hire-rates">Magic Hire Rates</Link></li>
 <li><Link to="/faq" className="hover:text-amber-300 transition-colors">FAQ</Link></li>
 <li><Link to="/contact" className="hover:text-amber-300 transition-colors">Contact</Link></li>
 <li><Link to="/sitemap.xml" className="hover:text-amber-300 transition-colors">Sitemap</Link></li>
 </ul>
 </div>

 {/* Get In Touch */}
 <div className="md:col-span-3">
 <h4 className="text-amber-300 text-xs uppercase tracking-[0.28em] font-bold mb-5">Get In Touch</h4>
 <ul className="space-y-4 text-sm text-white/85">
 <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-amber-300 shrink-0" /><a href={`tel:${CONTACT.phone1}`} className="hover:text-amber-300 transition-colors">{CONTACT.phone1}</a></li>
 <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-amber-300 shrink-0" /><a href={`mailto:${CONTACT.email}`} className="hover:text-amber-300 transition-colors break-all">{CONTACT.email}</a></li>
 <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-amber-300 shrink-0" /><span>{CONTACT.embarkation || "King Street Wharf"}<br/><span className="text-white/60">Darling Harbour, Sydney NSW 2000</span></span></li>
 </ul>
 </div>
 </div>

{/* CHARTER-FOR MEGA DIRECTORY · all event types we host as private charters */}
<div className="mt-14 pt-10 border-t border-white/10" data-testid="footer-charter-directory">
 <div className="flex items-baseline justify-between flex-wrap gap-3 mb-7">
  <h4 className="text-amber-300 text-xs uppercase tracking-[0.28em] font-bold">Charter Magic For</h4>
  <span className="text-white/55 text-[11px] uppercase tracking-[0.22em] font-bold">Every event is a private full-boat charter · capacity up to 120</span>
 </div>
 <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8">
  {CHARTER_GROUPS.map((g) => (
   <div key={g.heading}>
    <div className="text-white text-[11px] uppercase tracking-[0.22em] font-black mb-3">{g.heading}</div>
    <ul className="space-y-2 text-[13px] text-white/70 leading-[1.5]">
     {g.items.map((it) => (
      <li key={it.s}>
       <Link to={`/cruises/${it.s}`} className="hover:text-amber-300 transition-colors" data-testid={`footer-charter-${it.s}`}>{it.l}</Link>
      </li>
     ))}
    </ul>
   </div>
  ))}
 </div>
</div>


 {/* SEO paragraph */}
 <div className="mt-14 pt-10 border-t border-white/10 text-white/55 text-[12px] leading-relaxed max-w-5xl">
 <strong className="text-white/80">Magic Cruises Sydney Harbour</strong>, Sydney's premier private boat charter. Specialising in Sydney Harbour cruises, wedding boat hire, corporate event boats, birthday party cruises, NYE fireworks cruises, Vivid Sydney cruises, hens parties, and family day cruises. Departing daily from King Street Wharf, Darling Harbour, Circular Quay and Rose Bay. Cruise past the iconic Sydney Opera House, under the Sydney Harbour Bridge, around Fort Denison, Shark Island, Watsons Bay, Manly and Sydney's eastern beaches. Fully licensed bar, NSW Maritime survey approved, professional skipper and crew. Sydney's best private boat hire, harbour cruise hire and charter boat experience for up to 100 guests on the iconic Magic catamaran.
 </div>

 {/* Bottom row */}
 <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-white/55">
 <div>© {new Date().getFullYear()} Magic Cruises Sydney Harbour. All rights reserved.</div>
 <div className="flex gap-6">
 <Link to="/privacy" className="hover:text-amber-300 transition-colors" data-testid="footer-privacy">Privacy</Link>
 <Link to="/terms" className="hover:text-amber-300 transition-colors" data-testid="footer-terms">Terms</Link>
 <Link to="/sitemap.xml" className="hover:text-amber-300 transition-colors">Sitemap</Link>
 </div>
 </div>
 </div>
 </footer>
 );
}
